import React, {Component} from 'react';
import styled from "styled-components/macro";
import breakpoint from "styled-components-breakpoint";
import {ExternalLink,} from "../RoutingLinks/RoutingLinks";

const CookieNoticeWrapper = styled.div`
   ${breakpoint('s')`
    line-height: 3rem;
    `};
    margin-left:0;
    margin-right:0;
    visibility: visible;
    opacity: 1;
    ${props => props.clicked && `
        transform: translateY(-100%);
        visibility: hidden;
    `};
    transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), visibility 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), -webkit-transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    top: 4em;
    left: 0.5em;
    font-size: 0.8em;
    font-family: ${props => props.theme.largeTextFamily};
    background-color: #ebebeb;
`;

const Handle = styled.span`
        border: 1px solid rgba(0,0,0,.15);
        border-radius: 4px;
        padding-left: 0.2em;
        padding-right: 0.2em;
        &:hover {
            color: rgba(0,0,0,.68);
            border-color: rgba(0,0,0,.54);
            cursor: pointer;
        }
        margin-left: 1em;
`;

class CookieNotice extends Component {
    constructor(props) {
        super(props);
        const isAlreadyAccepted = localStorage.getItem('cookieAccepted');
        this.state = {clicked: isAlreadyAccepted}
    }

    consentHandler = () => {
        this.setState({clicked: !this.state.clicked});
        localStorage.setItem('cookieAccepted', "yes");
    };

    rejectHandler = () => {
        this.setState({clicked: !this.state.clicked});
        localStorage.setItem('cookieAccepted', "no");
    };

    render() {
        return (
            <CookieNoticeWrapper clicked={this.state.clicked}>
                <span>
                    This site uses cookies to analyse traffic in accordance with our
                    <ExternalLink to="https://envimate.com/PrivacyPolicy.html" displayText="Privacy Policy"/>.
                </span>
                <Handle onClick={this.consentHandler} clicked={this.state.clicked}><span>OK</span></Handle>
                <Handle onClick={this.rejectHandler} clicked={this.state.clicked}><span>Don't</span></Handle>
            </CookieNoticeWrapper>
        );
    }
}

export {CookieNotice};
